import { getOptions } from '@/api/device'
import { getMenu } from '@/api/image'
import { setLocalItem } from '@/utils/token'

const enumList = {
  state: {
    algorithmPlatforms: {},
    algorithmTypes: {},
    faceAgeOptions: {},
    faceEmotionOptions: {},
    bodyAttributeOptions: {},
    algorithmMetricsOptions: {},
    bodyDriverOptions: {},
    faceMaskOptions: {},
    bodyhelmetOptions: {},
    detectionFireOptions: {},
    bodyHeadShoulderOptions: {},
    bodyGestureOptions: {},
    bodyDetectionSmokingOptions: {},
    bodyReflectiveVestDetectionOptions: {},
    classificationAnimalOptions: {},
    classificationDishesOptions: {},
    classificationGeneralOptions: {},
    classificationVegetablesOptions: {},
    classificationVehicleTypeOptions: {},
    algorithmList: [],
    algorithmTypeList: {},
    aideBuiltinModel: {},
    aideInformation: {},
  },

  mutations: {
    SET_COMMON: (state, common) => {
      state.algorithmPlatforms = common.algorithmPlatforms
      state.algorithmTypes = common.algorithmTypes
      state.faceAgeOptions = common.faceAgeOptions
      state.faceEmotionOptions = common.faceEmotionOptions
      state.bodyAttributeOptions = common.bodyAttributeOptions
      state.algorithmMetricsOptions = common.algorithmMetricsOptions
      state.bodyDriverOptions = common.bodyDriverOptions
      state.faceMaskOptions = common.faceMaskOptions
      state.bodyhelmetOptions = common.bodyhelmetOptions
      state.detectionFireOptions = common.detectionFireOptions
      state.bodyHeadShoulderOptions = common.bodyHeadShoulderOptions
      state.bodyGestureOptions = common.bodyGestureOptions
      state.bodyDetectionSmokingOptions = common.bodyDetectionSmokingOptions
      state.bodyReflectiveVestDetectionOptions =
        common.bodyReflectiveVestDetectionOptions
      state.classificationAnimalOptions = common.classificationAnimalOptions
      state.classificationDishesOptions = common.classificationDishesOptions
      state.classificationGeneralOptions = common.classificationGeneralOptions
      state.classificationVegetablesOptions =
        common.classificationVegetablesOptions
      state.classificationVehicleTypeOptions =
        common.classificationVehicleTypeOptions
      state.aideBuiltinModel = common.aideBuiltinModel
      state.aideInformation = common.aideInformation
    },
    SET_MENU: (state, common) => {
      state.algorithmList = common
    },
    SET_TYPE: (state, common) => {
      state.algorithmTypeList = common.algorithm_types
    },
  },

  actions: {
    async getCommonEnumList({ commit }) {
      try {
        let res = await getOptions()
        commit('SET_COMMON', res)
        setLocalItem('options', JSON.stringify(res))
      } catch (fail) {
        console.error(fail)
      }
    },

    async getMenuList({ commit }) {
      try {
        let res = await getMenu()
        let algorithmList = []
        if (res.algorithm_categories) {
          algorithmList = res.algorithm_categories.map((i) => {
            return {
              ...i,
              children: [],
            }
          })
          Object.values(res.algorithm_types).forEach((j) => {
            const targetCategory = algorithmList.find(
              (i) => i.type === j.category,
            )
            if (targetCategory) {
              targetCategory.children.push(j)
            }
          })
        }
        setLocalItem('algorithmList', JSON.stringify(algorithmList))
        commit('SET_MENU', algorithmList)
        commit('SET_TYPE', res)
      } catch (fail) {
        console.error(fail)
      }
    },
  },
}

export default enumList
